import { Component } from '@angular/core';

import { ApParagraphSkeletonComponent, ApButtonSkeletonComponent, ApInputSkeletonComponent } from '@ap/skeleton';

/**
 * @ngdoc component
 * @name ApPhoneNumberSkeletonComponent
 */
@Component({
    selector: 'ap-sign-phone-number-skeleton',
    standalone: true,
    templateUrl: './skeleton.component.html',
    styleUrls: ['./skeleton.component.scss'],
    imports: [ApParagraphSkeletonComponent, ApInputSkeletonComponent, ApButtonSkeletonComponent]
})
export class ApPhoneNumberSkeletonComponent {}
